<template>
	<div class="detail-box">
		<van-skeleton title :row="20" v-if="!info.guideImage"/>
		<div class="ueditor-reset-diy" v-html="info.description"></div>
		<div :style="{height:`${imgButtonPlac}px`}"></div>
		<img class="imgButton" :src="info.guideImage" @load="imgButtonLoad" @click="getto">
	</div>
</template>

<script>
	export default{
		data(){
			return {
				imgButtonPlac:0,
				info:{}
			}
		},
		created() {
			this.$API.productDetail(this.$route.params).then(res => {
				this.info = res.data
			})
		},
		methods:{
			getto(){
				this.$router.push({
					path:`/mp_toutiao/pay/${this.$route.params.id}`,
					query:this.$route.query
				});
			},
			imgButtonLoad(e){
				this.imgButtonPlac = e.path[0].height;
			}
		}
	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	.ueditor-reset-diy{
		::v-deep img{
			display:block;
			width:100%;
		}
	}
	.detail-box
		.imgButton
			width 100%
			position fixed
			bottom 0
			left 0
</style>
